/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRoleForm,
  UpdateRoleForm$Outbound,
  UpdateRoleForm$outboundSchema,
} from "../components/updateroleform.js";

export type UpdateRoleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateRoleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateRoleForm: UpdateRoleForm;
};

/** @internal */
export type UpdateRoleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateRoleSecurity$outboundSchema: z.ZodMiniType<
  UpdateRoleSecurity$Outbound,
  UpdateRoleSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateRoleSecurityToJSON(
  updateRoleSecurity: UpdateRoleSecurity,
): string {
  return JSON.stringify(
    UpdateRoleSecurity$outboundSchema.parse(updateRoleSecurity),
  );
}

/** @internal */
export type UpdateRoleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpdateRoleForm: UpdateRoleForm$Outbound;
};

/** @internal */
export const UpdateRoleRequest$outboundSchema: z.ZodMiniType<
  UpdateRoleRequest$Outbound,
  UpdateRoleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    updateRoleForm: UpdateRoleForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      updateRoleForm: "UpdateRoleForm",
    });
  }),
);

export function updateRoleRequestToJSON(
  updateRoleRequest: UpdateRoleRequest,
): string {
  return JSON.stringify(
    UpdateRoleRequest$outboundSchema.parse(updateRoleRequest),
  );
}
